// extracted by mini-css-extract-plugin
export default {"containerNot":"Notifications_containerNot__G-vDj","notItem":"Notifications_notItem__+L3qC"};